// import config from "./config_dev";
// import config from "./config_aws_stg";
import config from "./config_prd";

import esriConfig from "@arcgis/core/config";

// Common configurations
const CONFIG_LANDSD_API_KEY = "584b2fa686f14ba283874318b3b8d6b0";
const CONFIG_LANDSD_API_URL = "https://api.hkmapservice.gov.hk/ags/gc/";
const CONFIG_LANDSD_GEOCODING_SETTING = {
  before: function(params) {
    if (params.url.indexOf("api.hkmapservice.gov.hk") >= 0) {
      if (params.requestOptions.query) {
        params.requestOptions.query.key = CONFIG_LANDSD_API_KEY;
      } else {
        params.requestOptions.query = {
          key: CONFIG_LANDSD_API_KEY,
        };
      }
    }
  },
  after: function(response) {
    if (!response.ssl) {
      response.ssl = true;
    }
  },
};
const CONFIG_LOCATION_SOURCES = [
  {
    name: "Address",
    placeholder: "Input Addresses",
    url: CONFIG_LANDSD_API_URL + "loc/address/en",
    singleLineFieldName: "SingleLine",
  },
  {
    name: "Building",
    placeholder: "Building Name",
    url: CONFIG_LANDSD_API_URL + "ib1000/buildings/building/en",
    singleLineFieldName: "SingleLine",
  },
  {
    name: "Lot",
    placeholder: "e.g SSTL 112,IL 10",
    url: CONFIG_LANDSD_API_URL + "ic1000/lot",
    singleLineFieldName: "SingleLine",
  },
  {
    name: "Man Made Slope",
  },
  {
    name: "Place Name",
    placeholder: "e.g Tsim Sha Tsui",
    url: CONFIG_LANDSD_API_URL + "ib5000/poi/placepoint/en",
    singleLineFieldName: "SingleLine",
  },
  {
    name: "Street Name",
    placeholder: "e.g. Nathan Road",
    url: CONFIG_LANDSD_API_URL + "loc/streetintersection/en",
    singleLineFieldName: "SingleLine",
  },
];

const CONFIG_SENDSUGGESTION = "WebAPI/GInfo/SendSuggestion";
const CONFIG_SISSUMMARY_PDF =
  "/WebAPI/ViewFile.aspx?f1=sis_summary&f2=sis_summary.pdf";
const CONFIG_LAYERUPDATES = "WebAPI/GInfo/LayerUpdates";
//"/ginfo_srv/api/WebAPI/GInfo/LayerUpdates";

// Set the ArcGIS JS API configuration here
esriConfig.portalUrl = config.portalUrl;
esriConfig.request.interceptors.push(CONFIG_LANDSD_GEOCODING_SETTING);
esriConfig.assetsPath = "./assets";
esriConfig.request.useIdentity = true;

document.title = config.websiteTitle || "CEDD GINFO";

const commonConfig = {
  authorizePage: "authorize.html",
  sessionTimeout: 10, // Hour
  FULL_EXTENT: {
    type: "extent",
    spatialReference: { latestWkid: 2326, wkid: 102140 },
    xmin: 792516.5895510133,
    ymin: 801081.7918000441,
    xmax: 872077.2642489864,
    ymax: 852142.3070000446,
  },
  DEFAULT_LAYERS: {
    "2D": {
      overlays: [
        ["Man Made Slope", 0.5, undefined],
        ["Ortho Photo", 1, "first", "hide"],
      ],
    },
    "3D": {
      overlays: [
        ["Man Made Slope", 0.5, undefined, "hide"],
        ["Ortho Photo", 1, "first"],
      ],
      layer3D: [
        ["LandsD 3D Bldg", 1, 0.5, "LandsD - 3D Spatial Dataset"],
        ["LandsD 3D Infra", 1, 0.5, "LandsD - 3D Spatial Dataset"],
      ],
    },
  },
  locationSearchSource: CONFIG_LOCATION_SOURCES,
  sendsuggestion: CONFIG_SENDSUGGESTION,
  sis_summary: CONFIG_SISSUMMARY_PDF,
  layerupdates: CONFIG_LAYERUPDATES,
};

export default {
  ...commonConfig,
  ...config,
};
